import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { FloatLabel } from "primereact/floatlabel";
import { useCallback, useState } from "react";
import { useAppContext } from "../../providers/ProviderAppContainer";
import TabHeader from "../common/TabHeader";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { useSelector } from "react-redux";
import CheckboxInput from "../common/CheckBoxInput";
import FileInput from "../common/FileInput";
import { TEXT_NORMAL } from "../../style";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import { AUTHORITIES } from "../../constants";

export default function DialogAddChapter({ visible, closeDialog, setChapters, subjectId, view_index }) {
    const { requestAPI, showToast } = useAppContext();

    const [chapter, setChapter] = useState();
    const [loading, setLoading] = useState();

    const { chapter_types = [] } = useSelector((state) => state.stateTemplateConfig?.global);

    const addSubject = useCallback(() => {
        requestAPI({
            requestPath: `chapters`,
            requestMethod: "POST",
            requestPostBody: { ...chapter, subject_id: subjectId, view_index },
            setLoading: setLoading,
            onRequestFailure: () => showToast({ severity: "error", summary: "Failed", detail: "Failed To Add Chapter !", life: 2000 }),
            onResponseReceieved: ({ error, ...addedChapter }, responseCode) => {
                if (addedChapter && responseCode === 201) {
                    showToast({ severity: "success", summary: "Added", detail: "Chapter Added", life: 1000 });
                    setChapters((prev) => [addedChapter, ...prev]);
                    closeDialog(); //close the dialog
                } else showToast({ severity: "error", summary: "Failed", detail: error || "Failed To Add Chapter !", life: 2000 });
            },
        });
    }, [chapter, closeDialog, requestAPI, setChapters, showToast, subjectId, view_index]);

    return (
        <Dialog pt={{ content: { className: "overflow-y-auto" } }} header={`Add New Chapter`} visible={visible} className="w-11" onHide={closeDialog}>
            <TabHeader className="pt-3" title="Add New Chapter" highlights={["New Chapter Will Be Added"]} />

            <FloatLabel className="mt-5">
                <InputText
                    value={chapter?.title || ""}
                    id="title"
                    className="w-full"
                    onChange={(e) => setChapter((prev) => ({ ...prev, title: e.target.value }))}
                    disabled={loading}
                />
                <label htmlFor="title">Title</label>
            </FloatLabel>

            <FloatLabel className="flex-1 mt-5">
                <Dropdown
                    className="w-full"
                    value={chapter_types?.find(({ id }) => id === chapter?.type)}
                    inputId="branch"
                    options={chapter_types}
                    optionLabel="title"
                    onChange={(e) => setChapter((prev) => ({ ...prev, type: e.value?.id }))}
                />
                <label htmlFor="branch">Type</label>
            </FloatLabel>

            <CheckboxInput
                className={"mt-3"}
                label={"Allow Test"}
                checked={!!chapter?.test_attainable}
                onChange={(checked) => setChapter((prev) => ({ ...prev, test_attainable: checked }))}
            />

            {!!chapter?.test_attainable && (
                <FileInput
                    className={"mt-3"}
                    label="Questions Sheet"
                    type="sheet"
                    cdn_url={chapter?.test_questions_pool}
                    setCDNUrl={(cdn_url) => setChapter((prev) => ({ ...prev, test_questions_pool: cdn_url }))}
                    disabled={loading}
                    pt={{
                        root: { className: TEXT_NORMAL },
                    }}
                />
            )}

            <HasRequiredAuthority requiredAuthority={AUTHORITIES.CREATE_CHAPTERS}>
                <Button className="mt-3" label="Add Subject" severity="warning" loading={loading} onClick={addSubject} />
            </HasRequiredAuthority>
        </Dialog>
    );
}
